module.exports = __webpack_public_path__ + "img/arrow-right-icon.3623091b.svg";